import { useCallback } from 'react'

import { InvoicePayload } from '@features/invoices/types/invoicePayload'

import { useRecurringInvoiceForm } from '../../contexts/recurringInvoiceFormContext'
import { RecurringInvoiceForm } from '../../types/recurringInvoiceForm/recurringInvoiceForm'
import { getRecurringInvoicePayload } from '../../utils/recurringInvoice/getRecurringInvoicePayload'

export const useRecurringInvoicePayload = () => {
  const { recurringInvoiceForm } = useRecurringInvoiceForm()
  const { getValues } = recurringInvoiceForm

  const getRecurringInvoiceDraftPayload = useCallback(
    (invoiceDraftPayload: InvoicePayload, recurringInvoiceFormValues?: RecurringInvoiceForm) => {
      const recurringInvoiceFormData = recurringInvoiceFormValues || getValues?.()

      return getRecurringInvoicePayload({ invoiceDraftPayload, recurringInvoiceFormData })
    },
    [getValues],
  )

  return { getRecurringInvoiceDraftPayload }
}
